import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const deltaSchema = z.object({
  /** トランザクション種別（例: withdraw) */
  type: z.string(),
  /** アセット名（例: ETH） */
  token: z.string().optional(),
  amount: decimalSchema.optional(),
  /** 手数料 */
  fee: decimalSchema.optional(),
  feeToken: z.string().optional(),
  user: z.string().optional(),
  destination: z.string().optional(),
  /** USDCでの金額 */
  usdc: decimalSchema.optional(),
  toPerp: z.boolean().optional(),
  vault: z.string().optional(),
  commission: decimalSchema.optional(),
  closingCost: decimalSchema.optional(),
})

const historySchema = z.object({
  /** 取引の詳細情報 */
  delta: deltaSchema,
  /** トランザクションハッシュ */
  hash: z.string(),
  /** タイムスタンプ（ミリ秒） */
  time: z.number().int(),
})

export const responseSchema = z.array(historySchema)
